import moment from "moment";
import api from "../../../api";

export function postClinicData(payload) {
  return api.post("/onBoardClinic", payload);
}

export function getClinicData(page) {
  return api.get(`all-clinics?page=${page}&pageSize=10`);
}

export function editClinicData(payload) {
  return api.put(`edit-clinic?clinic_id=${payload.clinic_id}`, payload);
}

export function searchClinic(query){
  return api.get(`searchClinicAdmin?searchQuery=${query}`)
}


export function getAssingedClinic(id) {
  return api.get(`get-assigned-clinic?case_id=${id}`);
}

export function getClinicDetails(id) {
  return api.get(`clinic-data?clinic_id=${id}`);
}

export function getNearestClinic(locality, pincode) {
  return api.get(`/search-nearest-clinics?locality=${locality}&pincode=${pincode}`);
}

export function assignClinic(payload) {
  return api.post('/add-update-assigned-clinic', payload);
}

export function patientsAssignedToClinics(adminid) {
  return api.get(`/get-assigned-patients?adminid=${adminid}`);
}

export function doctorsOfClinic(adminid) {
  return api.get(`/getDoctorsBasedOnClinic?clinicAdminId=${adminid}`);
}

export function cxAssignedClinic(caseId) {
  return api.get(`/assigned-clinics?caseId=${caseId}`);
}

export function assingDoctorToCX(payload) {
  return api.put(`/assign-doctor?`, payload);
}

export function getClinicAppointments(startDate, endDate, clinicId) {
  let url = `/api/clinic/clinic-appointments?start_date=${moment(startDate).valueOf()}&end_date=${moment(endDate).valueOf()}`;
  if (clinicId && clinicId !== 'n/a') url += `&clinic_id=${clinicId}`;
  return api.get(url);
}

export function clinicsSlots(body) {
  return api.post(`/api/clinic/doctor-slots?clinic_id=${body.location}`, body);
}

export function bookClinicSlot(body, clinicId) {
  return api.post(`polyclinic-appointment?clinic_id=${clinicId}`, body);
}

export const clinicPrescription = (payload) =>{
  return api.post(`api/clinic/write-prescription`, payload);
}

export const viewPrescriptionApi = (case_id) =>{
  return api.get(`api/clinic/view-prescription?case_id=${case_id}`);
}

export const editPresApi = ( pres_id,payload) =>{
  return api.put(`api/clinic/edit-prescription/${pres_id}`, payload);
}

export const uploadImagePres = (pres_id, payload) =>{
  return api.put(`api/clinic/prescription-doc/${pres_id}`, payload);
}

export const getClinicLocationsApi = () =>{
  return api.get(`polyclinic-map`);
}

export const markPaid = (paymentId) => {
  return api.put(`api/clinic/mark-clinic-doctor-appointment-paid/${paymentId}`)
}